import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';

export type GetEhrListResponse = {
  ehr: string[];
};

export type UseGetEhrListParams = {};

export type UseGetEhrListOptions = {
  enabled?: boolean;
};

export const useGetEhrList = (
  params?: UseGetEhrListParams,
  options?: UseGetEhrListOptions
) => {
  return useQuery({
    ...options,
    queryKey: ['ehrList', params],
    queryFn: () =>
      api
        .get<GetEhrListResponse>('/ehr')
        .then((res) => ({ ehrList: res.data?.ehr })),
  });
};
